export default {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  READY_FOR_VALIDATION: 'READY_FOR_VALIDATION',
}
